module.exports = __webpack_public_path__ + "img/4.751eb13c.jpg";